import React from "react";

const Home = () => {
  return (
    <div className="home_container">
    
      <div className="content">
        <div className="static-text">
          {/* <p className="greeting">Hello!</p> */}
          <p className="name">Hello! I'm Wais Nazari</p>
          <div>
            <div className="typing">
              <p>a Graphic Designer turned Developer</p>
              {/* <div className="dynamic-text">
                <ul>
                  <li>
                    <span> Designer</span>
                  </li>
                  <li>
                    <span> Developer</span>
                  </li>
                  <li>
                    <span> Traveler</span>
                  </li>
                  <li>
                    <span> Gardiner</span>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="img2"></div> */}
    </div>
  );
};

export default Home;
